:host(.gxg--disabled) .form-element,
:host(.gxg--disabled.form-element) {
  pointer-events: none;
  background-color: var(--gxg-background-color--disabled) !important;
  color: var(--gxg-color--disabled) !important;
  border-color: var(--gxg-border-color--disabled) !important;
  cursor: default !important;
}

:host {
  display: block;
}

ch-window::part(mask) {
  overflow: hidden;
}

ch-window::part(main) {
  height: 100%;
}

ch-window::part(window) {
  width: 100%;
  height: 100%;
}

.loader__wrapper {
  opacity: 0;
  transition: var(--show-transition) opacity;
  width: 100%;
  height: 100%;
  display: flex;
  background-color: rgba(var(--color-background--rgb), 0.45);
  backdrop-filter: blur(15px);
  padding: var(--spacing-comp-05);
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  -webkit-animation: wrapper 0.6s infinite alternate;
  animation: wrapper 0.6s infinite alternate;
  color: var(--color-on-secondary);
}
.loader__wrapper--visible {
  opacity: 1;
}
.loader__spinner {
  border: 2px var(--gray-01) solid;
  border-top: 2px var(--color-primary-enabled) solid;
  border-radius: 50%;
  -webkit-animation: spinner 0.6s infinite linear;
  animation: spinner 0.6s infinite linear;
  width: 30px;
  height: 30px;
}
.loader__content-wrapper {
  display: flex;
  flex-direction: column;
  margin-block-start: var(--spacing-comp-05);
  gap: var(--spacing-comp-02);
  max-width: 400px;
}
.loader__content-wrapper--hidden {
  display: none;
}
.loader__cancel-button--move-up {
  /*If the loader has title, but no description, the space between the title and the button is a little too much. Move up a little bit*/
  position: relative;
  top: -4px;
}

/*background color animation*/
@keyframes wrapper {
  from {
    background-color: rgba(var(--color-background--rgb), 0.45);
  }
  to {
    background-color: rgba(var(--color-background--rgb), 0.25);
  }
}
/*spinner animation*/
@-webkit-keyframes spinner {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
  }
}
@keyframes spinner {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}